import React from 'react';
import { Chip, Tooltip } from '@mui/material';

/** Shown on a document whose creator approved it themselves under the institution's approval controls. */
const SelfApprovedChip: React.FC<{ selfApproved?: boolean; rule?: string | null }> = ({ selfApproved, rule }) => {
    if (!selfApproved) return null;
    return (
        <Tooltip title={rule ? `Approved by its creator (${rule})` : 'Approved by its creator'}>
            <Chip label="Self-approved" color="warning" size="small" variant="outlined" sx={{ ml: 1 }} />
        </Tooltip>
    );
};

export default SelfApprovedChip;
